(function () {
  'use strict';

  /* ============================================================
     KIT EXPERIMENTAÇÃO — produto EXCLUSIVO no carrinho (03/Ago/2026)

     Regra de negócio:
       O Kit Experimentação (3 mini potes grátis + frete fixo R$29,90 de
       perfil dedicado) não pode dividir carrinho com nenhum outro produto.
       Se QUALQUER produto entra com o Kit presente → o Kit sai e o cupom
       KITEXPERIMENTACAOGRATIS é removido junto.

     Por que o cupom também sai:
       O Kit custa R$59,90 no catálogo; ele só fica grátis por causa do
       cupom que a LP injeta no permalink. O cupom vive no carrinho de forma
       INDEPENDENTE dos itens — removendo só o produto, o desconto continuaria
       aplicado sobre o que sobrou (furo observado em produção: -R$247,27
       abatidos num carrinho com creatina paga).

     O lado LP→carrinho já funciona sem código:
       Os CTAs da /pages/lp-kit-experimentacao usam CART PERMALINK
       (/cart/51373867368757:1?discount=...), e permalink RECONSTRÓI o
       carrinho do zero — já zera os outros produtos sozinho. Este guard
       cobre só o caminho inverso (adicionar por cima do Kit).

     Comportamentos não-óbvios:
       - Intercepta window.fetch e XMLHttpRequest: cobre TODOS os caminhos de
         adição de uma vez (PDP, order bump do drawer, pop-ups ups-*.js, Vex,
         apps de terceiros) em vez de tentar mapear cada botão.
       - EXCEÇÃO Sérum La Roche: é o Vex adicionando automaticamente ao bater
         R$384,90, não uma escolha da cliente. Se disparasse a regra, o Kit
         sumiria por ação do sistema — comportamento imprevisível pra cliente.
       - O Kit sendo re-adicionado (permalink da LP de novo) NÃO se auto-remove:
         a regra só age quando um item DIFERENTE do Kit entra.
       - Cupom digitado à mão sem o Kit no carrinho também é recusado, senão
         sobraria um caminho aberto pra usar o desconto fora do contexto.
       - Kaching (React) reescreve o drawer a cada render → o toast é re-injetado
         via MutationObserver, mesmo padrão do ab01-cart-upsell.js.

     Rollback: remover a linha do theme.liquid.
     ============================================================ */

  try {

    if (window.__GD_KIT_GUARD_LOADED) return;
    window.__GD_KIT_GUARD_LOADED = true;

    /* ======================== CONFIG ======================== */

    var KIT_VARIANT_ID   = 51373867368757;   // Kit Experimentação (R$59,90 no catálogo)
    var KIT_PRODUCT_ID   = '10245392400693'; // combo-guday-kit-experimentacao
    var SERUM_VARIANT_ID = 53242273235253;   // brinde La Roche (Vex) — não dispara a regra
    var KIT_COUPON_RE   = /^KITEXPERIMENTACAO/i;

    var TOAST_ID  = 'gd-kit-toast';
    var STYLE_ID  = 'gd-kit-guard-css';

    var MSG_REMOVED = '<b>Kit Experimentação removido.</b> Ele é exclusivo e não pode ser combinado com outros produtos.';
    var MSG_COUPON  = '<b>Cupom não aplicado.</b> Ele vale apenas para o Kit Experimentação sozinho no carrinho.';

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* ======================== CSS ======================== */

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var css =
        '#' + TOAST_ID + '{display:flex;align-items:flex-start;gap:8px;' +
        'margin:0 16px 10px;padding:10px 12px;background:#FFF6E5;border:1px solid #F2D9A8;' +
        'border-left:3px solid #E8A33D;border-radius:8px;font-size:12.5px;color:#6B4A12;' +
        'line-height:1.45;animation:gd-kit-in .35s cubic-bezier(.22,.8,.35,1);}' +
        '@keyframes gd-kit-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}' +
        '#' + TOAST_ID + ' .gd-kit-ico{flex-shrink:0;font-size:14px;line-height:1.2;}' +
        '#' + TOAST_ID + ' .gd-kit-txt{flex:1;}' +
        '#' + TOAST_ID + ' .gd-kit-txt b{color:#4A330A;}' +
        '#' + TOAST_ID + ' .gd-kit-x{background:none;border:0;cursor:pointer;color:#8a6a30;' +
        'font-size:15px;line-height:1;padding:0 2px;}';
      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = css;
      document.head.appendChild(st);
    }

    /* ======================== TOAST ======================== */

    // Mensagem pendente: sobrevive ao re-render do Kaching até ser exibida.
    var pendingMsg = null;

    function mountToast() {
      if (!pendingMsg) return;
      var drawer = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                   document.querySelector('.kaching-cart__contents');
      if (!drawer) return;                       // drawer fechado: espera abrir
      if (document.getElementById(TOAST_ID)) return;

      var el = document.createElement('div');
      el.id = TOAST_ID;
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="gd-kit-ico">ℹ️</span>' +
                     '<span class="gd-kit-txt">' + pendingMsg + '</span>' +
                     '<button class="gd-kit-x" type="button" aria-label="Fechar aviso">✕</button>';
      drawer.insertBefore(el, drawer.firstChild);

      el.querySelector('.gd-kit-x').addEventListener('click', function () {
        pendingMsg = null;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    }

    function notify(msg) {
      pendingMsg = msg;
      mountToast();
    }

    /* ======================== CART HELPERS ======================== */

    function getCart() {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    }

    function isKitLine(item) {
      return String(item.variant_id) === String(KIT_VARIANT_ID) ||
             String(item.product_id) === KIT_PRODUCT_ID;
    }

    function cartHasKit(cart) {
      return (cart.items || []).some(isKitLine);
    }

    // Remove a linha do Kit (quantity 0) — /cart/change.js aceita id da LINHA.
    function removeKitLines(cart) {
      var lines = [];
      (cart.items || []).forEach(function (it, i) {
        if (isKitLine(it)) lines.push(i + 1);      // change.js é 1-indexed
      });
      if (!lines.length) return Promise.resolve(false);

      // Remove de trás pra frente: tirar a linha 1 renumera as seguintes.
      var chain = Promise.resolve();
      lines.sort(function (a, b) { return b - a; }).forEach(function (line) {
        chain = chain.then(function () {
          return fetch(ROOT + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ line: line, quantity: 0 })
          });
        });
      });
      return chain.then(function () { return true; });
    }

    // Limpa o cupom do Kit. /discount/ é o caminho oficial de aplicar;
    // para remover, o Shopify aceita cupom vazio no update de carrinho.
    function clearKitCoupon() {
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: '' })
      }).catch(function () { /* silencioso: alguns temas não expõem */ });
    }

    function refreshKaching() {
      try {
        if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
          var r = window.kachingCartApi.refreshCart();
          if (r && typeof r.catch === 'function') r.catch(function () {});
        }
      } catch (e) {}
    }

    /* ======================== A REGRA ======================== */

    var enforcing = false;

    // Roda depois de QUALQUER mutação de carrinho detectada.
    // addedVariantId: o que acabou de entrar (quando dá pra saber).
    function enforce(addedVariantId) {
      if (enforcing) return Promise.resolve();
      enforcing = true;

      return getCart().then(function (cart) {
        var items = cart.items || [];
        if (!cartHasKit(cart)) { enforcing = false; return; }

        // Itens que NÃO são o Kit e NÃO são o brinde do sistema.
        var intruders = items.filter(function (it) {
          return !isKitLine(it) && String(it.variant_id) !== String(SERUM_VARIANT_ID);
        });

        if (!intruders.length) { enforcing = false; return; }

        // Guarda de sanidade: nunca esvaziar o carrinho. Se o Kit é a única
        // linha "removível" e não há mais nada, não faz nada.
        if (items.length <= 1) { enforcing = false; return; }

        return removeKitLines(cart)
          .then(function (removed) {
            if (!removed) return;
            return clearKitCoupon().then(function () {
              notify(MSG_REMOVED);
              refreshKaching();
            });
          })
          .then(function () { enforcing = false; })
          .catch(function (e) {
            enforcing = false;
            console.warn('[KIT-GUARD] falha ao aplicar a regra:', e);
          });
      }).catch(function (e) {
        enforcing = false;
        console.warn('[KIT-GUARD] falha ao ler o carrinho:', e);
      });
    }

    /* ======================== INTERCEPTAÇÃO ======================== */

    // URLs que MUTAM o carrinho e devem disparar a regra.
    function isCartMutation(url) {
      if (!url) return false;
      var u = String(url);
      return /\/cart\/add(\.js)?(\?|$)/.test(u) ||
             /\/cart\/change(\.js)?(\?|$)/.test(u) ||
             /\/cart\/update(\.js)?(\?|$)/.test(u);
    }

    // Só /cart/add dispara a regra: change/update são o próprio guard agindo
    // (ou a cliente mexendo em quantidade), e re-disparar causaria laço.
    function isAdd(url) {
      return url && /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }

    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url);
        var p = origFetch.apply(this, arguments);
        if (isAdd(url)) {
          // Observa o resultado SEM consumir o body (só lê res.ok) e devolve a
          // Promise original intacta — o chamador (tema/app) segue lendo o
          // response normalmente. Um .then() aqui não clona nem trava o body.
          p.then(function (res) {
            if (res && res.ok) setTimeout(function () { enforce(); }, 60);
          }, function () { /* erro de rede: nada a fazer */ });
        }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gdKitUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isAdd(xhr.__gdKitUrl)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function () { enforce(); }, 60);
          }
        });
      }
      return origSend.apply(this, arguments);
    };

    /* ======================== CUPOM DIGITADO À MÃO ======================== */

    // Se a cliente colar KITEXPERIMENTACAO* sem o Kit no carrinho, recusa.
    function watchCouponField() {
      document.addEventListener('click', function (ev) {
        var btn = ev.target && ev.target.closest &&
                  ev.target.closest('.kaching-cart__discount-code-apply');
        if (!btn) return;
        var input = document.querySelector('.kaching-cart__discount-code-input');
        if (!input) return;
        var code = (input.value || '').trim();
        if (!KIT_COUPON_RE.test(code)) return;

        getCart().then(function (cart) {
          if (cartHasKit(cart)) return;          // com o Kit: cupom é legítimo
          clearKitCoupon().then(function () {
            notify(MSG_COUPON);
            refreshKaching();
          });
        }).catch(function () {});
      }, true);
    }

    /* ======================== OBSERVER (re-injeta o toast) ======================== */

    function observe() {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          mountToast();
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.__GD_KIT_MO = mo;
    }

    /* ======================== BOOT ======================== */

    injectCSS();
    watchCouponField();
    observe();

    // Carrinho pode já estar "sujo" de uma sessão anterior (cliente fechou o
    // browser com Kit + outro produto). Uma verificação no load resolve.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { enforce(); });
    } else {
      enforce();
    }

  } catch (e) {
    console.warn('[KIT-GUARD] fatal error:', e);
  }
})();
